export const actionNamespace = 'ssm-web-app';
